
import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import authService from "../../../Services/authService";

const HeroSlider = () => {
  // const slides = [
  //   {
  //     image: "/images/hero-doctor-patient-new.png",
  //     alt: "Doctor administering a test to a patient",
  //     title: "Health Tests at Home",
  //     description: "The best of doctors, technology and care you deserve now available for you at your doorstep.",
  //     ctaText: "Request Callback",
  //     ctaLink: "#",
  //   },
  //   {
  //     image: "/images/hero-coronavirus-test.jpeg",
  //     alt: "Medical professional holding a test sample",
  //     title: "Comprehensive Health Checkups",
  //     description: "Early detection is key to better health outcomes. Book your preventive health checkup today.",
  //     ctaText: "View Packages",
  //     ctaLink: "#",
  //   },
  //   {
  //     image: "/images/hero-blood-test.jpeg",
  //     alt: "Blood sample test tube for laboratory analysis",
  //     title: "Advanced Diagnostic Tests",
  //     description:
  //       "State-of-the-art diagnostic services with accurate and timely results for informed healthcare decisions.",
  //     ctaText: "Explore Tests",
  //     ctaLink: "#",
  //   },
  // ];

  const [currentSlide, setCurrentSlide] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const intervalRef = useRef(null);
  const [slides, setSlides] = useState([]);
  const [categories, setCategory] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadBanners();
  }, []);

  const loadBanners = () => {
    const url = new URL(authService.getApiUrl() + 'bannerslist');
    fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=UTF-8',
        //Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        // if (res.status === 401) {
        //   authService.clientlogout();
        //   window.location.href = "/login";
        // } else {
        return res.json();
        //}
      })
      .then((result) => {
        setSlides(result.data || []);
        setCategory(result.categories || []);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err.message);
        setSlides([]);
        setCategory([]);
        setIsLoading(false);
      });
  };

  const nextSlide = () => {
    if (isTransitioning || !slides || slides.length === 0) return;
    setIsTransitioning(true);
    setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
    setTimeout(() => setIsTransitioning(false), 500);
  };

  const prevSlide = () => {
    if (isTransitioning || !slides || slides.length === 0) return;
    setIsTransitioning(true);
    setCurrentSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
    setTimeout(() => setIsTransitioning(false), 500);
  };

  const goToSlide = (index) => {
    if (isTransitioning || index === currentSlide) return;
    setIsTransitioning(true);
    setCurrentSlide(index);
    setTimeout(() => setIsTransitioning(false), 500);
  };

  useEffect(() => {
    if (slides && slides.length > 0) {
      intervalRef.current = setInterval(() => {
        nextSlide();
      }, 5000);
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [currentSlide, slides]);

  if (isLoading) {
    return (
      <div className="relative w-full overflow-hidden bg-[#1D1D1F] h-[500px] md:h-[600px] flex items-center justify-center">
        <div className="text-white">Loading...</div>
      </div>
    );
  }

  return (
    <div className="relative w-full overflow-hidden bg-[#1D1D1F]">
      <div className="relative h-[500px] md:h-[600px]">
        {slides && slides.length > 0 && slides.map((slide, index) => (
          <div
            key={index}
            className={`absolute inset-0 w-full h-full transition-opacity duration-500 ease-in-out ${currentSlide === index ? "opacity-100 z-10" : "opacity-0 z-0"
              }`}
          >
            <div className="absolute inset-0 w-full h-full">
              <img src={authService.getApiDomainUrl() + slide.image || "/placeholder.svg"} alt={slide.title} className="object-cover w-full h-full" />
              <div className="absolute inset-0 bg-gradient-to-r from-[#1D1D1F]/80 to-transparent md:bg-gradient-to-t md:from-[#1D1D1F]/70 md:via-[#1D1D1F]/40 md:to-transparent"></div>
            </div>

            <div className="absolute inset-0 flex items-center">
              <div className="container mx-auto px-4 md:px-12 lg:px-16 max-w-6xl">
                <div className="max-w-lg">
                  <h1 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-white tracking-tight mb-4 drop-shadow-md">
                    {slide.title}
                  </h1>
                  <p className="text-lg md:text-xl text-white/90 max-w-lg mb-6 drop-shadow">{slide.description}</p>
                  <div className="mb-6">
                    <a
                      href="tel:919966060000"
                      className="inline-block bg-[#951C25] text-white px-8 py-3 rounded-full text-sm font-medium hover:bg-[#951C25]/90 transition-colors"
                    >
                      Request Callback
                    </a>
                  </div>
                  {/* <div className="flex flex-wrap gap-3">
                    <button className="px-5 py-2 bg-white/20 backdrop-blur-sm border border-white/30 rounded-full text-sm font-medium text-white hover:bg-white/30 transition-colors">
                      Full Body Checkups
                    </button>
                    <button className="px-5 py-2 bg-white/20 backdrop-blur-sm border border-white/30 rounded-full text-sm font-medium text-white hover:bg-white/30 transition-colors">
                      Diabetes
                    </button>
                    <button className="px-5 py-2 bg-white/20 backdrop-blur-sm border border-white/30 rounded-full text-sm font-medium text-white hover:bg-white/30 transition-colors">
                      Heart
                    </button>
                  </div> */}
                  <div className="flex flex-wrap gap-3">
                    {categories && categories.length > 0 && categories.slice(0, 3).map((cat) => (
                      <Link
                        to={'/' + encodeURIComponent(cat.category_name.replace(/ /g, '-'))}
                        key={cat.id}
                        className="px-5 py-2 bg-white/20 backdrop-blur-sm border border-white/30 rounded-full text-sm font-medium text-white hover:bg-white/30 transition-colors"
                      >
                        {cat.category_name}
                      </Link>
                    ))}
                  </div>

                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <button
        onClick={prevSlide}
        className="absolute left-2 top-1/2 -translate-y-1/2 z-20 w-10 h-10 rounded-full bg-white/20 backdrop-blur-sm border border-white/30 flex items-center justify-center text-white hover:bg-white/30 transition-colors"
        aria-label="Previous slide"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polyline points="15 18 9 12 15 6"></polyline>
        </svg>
      </button>

      <button
        onClick={nextSlide}
        className="absolute right-2 top-1/2 -translate-y-1/2 z-20 w-10 h-10 rounded-full bg-white/20 backdrop-blur-sm border border-white/30 flex items-center justify-center text-white hover:bg-white/30 transition-colors"
        aria-label="Next slide"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polyline points="9 18 15 12 9 6"></polyline>
        </svg>
      </button>

      <div className="absolute bottom-6 left-0 right-0 z-20 flex justify-center gap-2">
        {slides && slides.length > 0 && slides.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`w-2 h-2 rounded-full transition-all duration-300 ${currentSlide === index ? "bg-[#951C25] w-6" : "bg-white/50 hover:bg-white/70"
              }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default HeroSlider;
